// 描述： 项目首页接口
// 时间： 2020 / 6 / 11
// created by zjj
// 
import request from '../request.js'

//项目首页 头部接口 郑智会
const selectProjectSum = function (data) {
    return request({
        url: 'busProContract/selectProjectSum',
        method: 'post',
        data
    })
}

//首页-饼状图（按地区，按季度，按项目类型，按项目金额）李开明
const pieChart = function (data) {
    return request({
        url: 'busProContract/pieChart',
        method: 'post',
        data
    })
}

//首页-柱状图（按地区，按项目类型，按月份）李开明
const barChart = function (data) {
    return request({
        url: 'busProContract/barChart',
        method: 'post',
        data
    })
}

/**
* 描述：保存项目的 当前的 标签信息
* 接口管理员：李开明
* 参数：
{
    objectId: this.curRowId,
    objectName: this.curRowName,
    applys: "1001025001001",
    busUnit: "1001025001",
    createUserid: this.userInfo.id,
    createUser: this.userInfo.sname,
    addTags: this.selectedTags,
    deleteTags: [],
}
*/
export const saveObjectTags = function (data) {
    return request({
        url: 'operateTagObject/saveObjectTags',
        method: 'post',
        data,
    })
}

/**
* 描述：获得项目的 当前的 标签信息
* 接口管理员：李开明
* 参数：
{
    objectId: '',   // 当前主键ID
    applys: '1001025001001',
    busUnit: '1001025001',
    createUserid: ''    // 创建人ID
}
*/
export const getObjectTags = function (data) {
    return request({
        url: 'operateTagObject/getObjectTags',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
* 描述：获得项目的 所有的 标签信息
*/
export const selectTagListForBox = function (data) {
    return request({
        url: 'operateTag/selectTagListForBox',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

export {
    selectProjectSum,
    pieChart,
    barChart
}